import React, { useLayoutEffect, useRef, FunctionComponent } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

interface ScrollTopPropsI {
  children?: React.ReactNode;
}

export const ScrollToTop: FunctionComponent<ScrollTopPropsI> = ({ children }) => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  // Se lee por ref: el efecto sólo corre al cambiar `pathname`. Si dependiera del tipo,
  // un `setSearchParams` (PUSH/REPLACE) después de un POP lo volvería a disparar y
  // mandaría al tope sin haber cambiado de pantalla.
  const navigationTypeRef = useRef(navigationType);
  navigationTypeRef.current = navigationType;

  // Layout effect + `instant`: the reset happens before the new route paints and
  // overrides the global `scroll-behavior: smooth`, which otherwise made every new
  // page appear at the previous scroll offset and then glide to the top.
  //
  // Atrás/adelante (`POP`) conserva la posición: el navegador ya restaura el scroll y
  // resetearlo mandaba a la persona al tope de la lista de la que venía.
  useLayoutEffect(() => {
    if (navigationTypeRef.current === 'POP') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return <>{children}</>;
};
